import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { Tooltip } from '@components/common';
import Actions from '@components/common/Actions';

import { columnSizes } from '@constants/table';
import { editTooltipText } from './constants';

import manageErrorCodesStyles from './ManageErrorCodes.module.scss';
import styles from '@components/common/Table/Table.module.scss';

export const getColumns = ({
	setEditableErrorCode,
	toggleShowErrorCodesFormModal,
}: {
	setEditableErrorCode: any;
	toggleShowErrorCodesFormModal: () => void;
}) => ([
	{
		header: 'ERROR CODE',
		accessorKey: 'code',
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<Tooltip content={value}>
					<span className={manageErrorCodesStyles.rowContent}>
						{value}
					</span>
				</Tooltip>
			);
		},
	},
	{
		header: 'Human-readable description',
		accessorKey: 'message',
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<Tooltip content={value}>
					<span className={manageErrorCodesStyles.rowContent}>
						{value}
					</span>
				</Tooltip>
			);
		},
	},
	{
		header: () => (
			<div className={styles.centerColumnHeader}>
				Actions
			</div>
		),
		accessorKey: 'id',
		enableSorting: false,
		size: columnSizes.size90,
		cell: ({ row }: CellContext<any, any>) => {
			const handleEdit = () => {
				setEditableErrorCode(row?.original);
				toggleShowErrorCodesFormModal();
			};

			return (
				<Actions
					editHandler={handleEdit}
					editTooltip={editTooltipText}
					gridNumberOfColumns={1}
					isEdit
				/>
			);
		},
	},
]);
